(() => {
  const source = document.getElementById('StorefrontLocalization');
  if (!source) return;
  const labels = JSON.parse(source.textContent);
  const format = (key, values) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`[${name}]`, value), labels[key]);
  const setAttribute = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };
  const setText = (element, value) => {
    if (element.textContent !== value) element.textContent = value;
  };
  const localizeElement = (element) => {
    const label = element.getAttribute('aria-label') || '';
    let match;
    const alt = element.getAttribute('alt');
    if (alt?.includes('Hungary')) setAttribute(element, 'alt', alt.replace(/\bHungary\b/g, labels.hungary));
    if (element.matches('.flickity-page-dot') && (match = label.match(/^View slide (\d+)$/))) {
      setAttribute(element, 'aria-label', format('view_slide', {index: match[1]}));
    }
    if (!element.closest('.jdgm-widget')) return;
    if ((match = label.match(/^Average rating is ([\d.]+) stars$/))) {
      setAttribute(element, 'aria-label', format('review_average', {rating: match[1].replace('.', ',')}));
    } else if ((match = label.match(/^([\d.]+)% \((\d+)\) reviews with (\d) star rating$/))) {
      setAttribute(element, 'aria-label', format('review_distribution', {percent: match[1].replace('.', ','), count: match[2], stars: match[3]}));
    } else if ((match = label.match(/^(\d) star review$/))) {
      setAttribute(element, 'aria-label', format('review_stars', {stars: match[1]}));
    } else if (element.matches('.jdgm-paginate__page') && (match = label.match(/^Page (\d+)$/))) {
      setAttribute(element, 'aria-label', format('review_page', {page: match[1]}));
    }
    if (element.matches('.jdgm-write-rev-link') && element.textContent.trim() === 'Write a review') setText(element, labels.write_review);
    if (element.getAttribute('alt') === 'Verified Checkmark') setAttribute(element, 'alt', labels.verified_checkmark);
    if (element.matches('.jdgm-rev__timestamp') && (match = (element.getAttribute('datetime') || '').match(/^(\d{4})-(\d{2})-(\d{2})/))) {
      setText(element, `${match[1]}. ${match[2]}. ${match[3]}.`);
    }
    if (element.matches('.jdgm-rev-widg__summary-average')) setText(element, element.textContent.replace(/(\d)\.(\d)/g, '$1,$2'));
  };
  const selector = '[aria-label], [alt], .jdgm-write-rev-link, .jdgm-rev__timestamp, .jdgm-rev-widg__summary-average';
  const localizeTree = (node) => {
    if (node.nodeType !== 1) return;
    localizeElement(node);
    node.querySelectorAll(selector).forEach(localizeElement);
  };
  localizeTree(document.documentElement);
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        if (mutation.target.nodeType === 1) localizeElement(mutation.target);
        mutation.addedNodes.forEach(localizeTree);
      } else if (mutation.type === 'characterData') {
        if (mutation.target.parentElement) localizeElement(mutation.target.parentElement);
      } else {
        localizeElement(mutation.target);
      }
    }
  });
  observer.observe(document.body, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'alt', 'datetime']});
})();
